import React,{useEffect} from 'react'
import "./soon.css"
import beefLogo from "../../images/beefLogo.png"
import cheeseLogo from "../../images/cheeseLogo.png"
import { useTranslation } from 'react-i18next';


const ComingSoon = () => {

  const { t, i18n } = useTranslation();

  return (
    <div className="comingSoon">
            <div className="logoContainer">
                <img src={beefLogo} alt="Beef Team Logo" className="beefImg"/>
                <img src={cheeseLogo} alt="Cheese Team Logo" className='cheeseImg'/>
            </div>

            <div>
                  <div className="text text1">{t('soonPage1')}</div>
                  <div className="text text2">{t('soonPage2')}</div>     
                  <div className="text text3">{t('soonPage3')}</div>    
            </div>
    </div>
  )
}

export default ComingSoon